export const state = () => ({
	job_spec: null,
	cipc_doc: null,
});
export const mutations = {
	setJobSpecDocument(state: any, payload: any) {
		state.job_spec = payload;
	},

	setCipcDocument(state: any, payload: any) {
		state.cipc_doc = payload;
	},
};
export const getters = {
	getJobSpecDocument: (state: any) => state.job_spec,
	getCipcDocument: (state: any) => state.cipc_doc,
};
export const actions = {
	// async fetchJobSpecDocument(state: any, payload: any) {
	// 	return new Promise((resolve, reject) => {
	// 		this.$axios
	// 			.get('/api/industries')
	// 			.then((res) => {
	// 				state.commit('setIndustries', res.data);
	// 				resolve(res.data);
	// 			})
	// 			.catch((err) => {
	// 				reject(err);
	// 			});
	// 	});
	// },

	async storeCipcDocument(state: any, payload: any) {
		const { data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/company/' + state.rootState.auth.user.company.uuid + '/cipc-document', data)
				.then((res) => {
					state.commit('setCipcDocument', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async storeJobSpecDocument(state: any, payload: any) {
		const { job_uuid, data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`api/jobs/${job_uuid}/documents`, data)
				.then((res) => {
					state.commit('setJobSpecDocument', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/documents/' + payload.uuid, payload.data)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/documents/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getDocumentUrl(state: any, documentUuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/documents/${documentUuid}`)
				.then((res) => resolve(res.data))
				.catch((err) => reject(err));
		});
	},

	async getCandidateDocumentUrl(state: any, documentUuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/candidate/documents/${documentUuid}`)
				.then((res) => resolve(res.data))
				.catch((err) => reject(err));
		});
	},
};
